export default function () {
  // this.getStaticComapny()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/statistics/resources/mounted.js